<template>
    <!-- v-show="showState" -->
    <div class="preorder-content" v-show="showState">
        <div class="buy-car-title">预售清单</div>
        <div class="goods-list">
            <div v-for="(item, index) in dataList" v-bind:key="index">
                <div class="goods-item">
                    <el-checkbox class="good-c" @change="handleCheckedChange" v-model="item.IsCheck"></el-checkbox>
                    <img :src="item.MainImg ? downloadUrl + item.MainImg + '?imageView2/2/w/100' : ''" alt
                        :onerror="defaultImg" />
                    <div class="good-msg">
                        <div class="goods-n" :title="item.GoodName">{{ item.GoodName }}</div>
                        <div class="goods-n" :title="item.APCode">{{ item.APCode }}</div>
                    </div>
                    <div class="good-msg">
                        <p>
                            <span class="goods-price" @click="editPrice(index)" v-if="!item.IsEdit">
                                <div class="goods-in">￥{{ item.MarketPrice }}</div>
                                <div class="goods-in">×{{ item.Count }}</div>
                            </span>
                            <span class="goods-price" v-else>
                                <div class="goods-in">￥<el-input v-model="item.MarketPrice" size="mini"
                                        @change="goodsChange"></el-input></div>
                                <div class="goods-in">×<el-input type="number" width="10px" v-model="item.Count" size="mini"
                                        @change="goodsChange"></el-input></div>
                            </span>
                        </p>
                    </div>
                    <div class="good-msg">
                        <p class="del-btn" @click="delGoods(index)"><i class="el-icon-delete"></i></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="car-msg">
            <span class="good-c"><el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="checkedAll">全选</el-checkbox></span>
            <span class="good-c">共{{ checkedNum }}件 &nbsp; 共计￥{{ checkedPrice.toFixed(2) }}</span>
            <el-button class="btn-primary" size="mini" @click="gotoOrder">去下单</el-button>
            <el-button type="danger" size="mini" @click="clearPreOrder" icon="el-icon-delete"></el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: ['showState'],
    data() {
        return {
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            tableDataLength: 0,
            nowHgIndex: -1, // 当前执行换购商品的索引
            nowHgChosen: false,
            hgList: [], // 这个是动态变的
            showHg: false,
            showPromotion: false, // 促销
            dataList: [], // 商品和套装列表
            checkedList: [], // 选中的商品和套装列表
            checkedNum: 0, // 选中的商品和套装的数量
            checkedPrice: 0, // 选中的商品和套装的折后总价
            checkedOriginalPrice: 0, // 选中的商品和套装的原价
            downloadUrl: this.$util.QN_URL_BASE,
            noData: false,
            checkAll: false,
            isIndeterminate: true
        };
    },
    methods: {
        gotoOrder() {
            if (!this.dataList || this.dataList.length == 0) {
                this.$util.warningMsg("暂未有待售商品，请先添加待售商品");
                return;
            }
            //判断当前的页面是不是开单页
            //加到草稿，然后跳转
            let sale_dataList = [];
            let new_dataList = [];
            let isHaveCheck = false;
            for (let i = 0; i < this.dataList.length; i++) {
                if (this.dataList[i].IsCheck) {
                    isHaveCheck = true;
                    let newGoods = {
                        ReferencePrice: this.dataList[i].MarketPrice,
                        EntpTempGoodsId: this.dataList[i].Id,
                        APCode: this.dataList[i].APCode,
                        GoodName: this.dataList[i].GoodName,
                        GoodNameItem: this.dataList[i].GoodName,
                        AutoSerise: this.dataList[i].AutoSerise,
                        AutoSeriseItem: this.dataList[i].AutoSerise,
                        Count: this.dataList[i].Count,
                        MarketPrice: this.dataList[i].MarketPrice,
                        Unit: this.dataList[i].Unit,
                        Origin: this.dataList[i].Origin,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: this.dataList[i].Inventory,
                        StorageInventory: this.dataList[i].Inventory,
                        WarehousedCount: 0,
                        State: 0,
                        canEdit: true,
                        CostPrice: this.dataList[i].CostPrice,
                        BillingPrice: this.dataList[i].MarketPrice == 0 ? '' : this.dataList[i].MarketPrice,
                        Size: this.dataList[i].Size
                    };

                    sale_dataList.push(newGoods);
                } else {
                    new_dataList.push(this.dataList[i]);
                }
            }

            if (isHaveCheck) {
                this.$util.setLocalStorage('preOrderGoodsList', new_dataList);
                this.$util.setLocalStorage('salesOrder_dataList', sale_dataList);
                this.$store.commit('updateShowPreOrder', new_dataList.length);

                this.$store.commit('updateEditOrder', 1);
                if (this.$router.currentRoute.path != '/salesManage/salesOrder/edit_v3') {
                    this.$router.push('/salesManage/salesOrder/edit_v3?type=0&id=');
                }
            }
            else {
                this.$util.warningMsg("请选中要下单的待售商品");
            }
        },
        // 读取购物车数据计算数量
        getTableData() {
            let data = this.$util.getLocalStorage('preOrderGoodsList');
            if (data) {
                this.dataList = data;
                let _checkedNum = data.length;
                this.$emit('getNum', _checkedNum);
                this.checkedNum = 0;
                this.checkedPrice = 0;
                for (let i = 0; i < this.dataList.length; i++) {
                    this.dataList[i].IsEdit = false;
                    this.dataList[i].IsCheck = false;
                    this.checkedNum += this.dataList[i].Count * 1;
                    this.checkedPrice += this.dataList[i].Count * this.dataList[i].MarketPrice;
                }
            }
        },
        // 商品从购物车删除
        delGoods(index) {
            this.dataList.splice(index, 1);
            this.$util.setLocalStorage('preOrderGoodsList', this.dataList);
            this.$emit('getNum', this.dataList.length);
            if (this.dataList.length == 0) {
                this.$store.commit('updateShowPreOrder', this.dataList.length);
            }
        },
        clearPreOrder() {
            this.$confirm('您是否要清空预售商品清单', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.dataList = [];
                    this.$util.setLocalStorage('preOrderGoodsList', this.dataList);
                    this.$store.commit('updateShowPreOrder', this.dataList.length);
                })
                .catch(() => { });
        },
        checkedAll(val) {
            if (val) {
                for (let i = 0; i < this.dataList.length; i++) {
                    this.dataList[i].IsCheck = true;
                }
            } else {
                for (let i = 0; i < this.dataList.length; i++) {
                    this.dataList[i].IsCheck = false;
                }
            }
            this.isIndeterminate = false;
        },
        handleCheckedChange(value) {
            let checkedCount = 0;
            for (let i = 0; i < this.dataList.length; i++) {
                if (this.dataList[i].IsCheck) checkedCount += 1;
            }
            this.checkAll = checkedCount === this.dataList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataList.length;
        },
        editPrice(index) {
            for (let i = 0; i < this.dataList.length; i++) {
                if (i != index) this.dataList[i].IsEdit = false;
                else this.dataList[i].IsEdit = true;
            }
        },
        goodsChange() {
            this.$util.setLocalStorage('preOrderGoodsList', this.dataList);
        }
    }
};
</script>
<style lang="less" scoped>
.goods-in {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 30px;
    width: 43px;
}

.del-btn {
    cursor: pointer;
    margin-left: 10px;
    color: rgb(253, 113, 113);
}

.goods-list {
    max-height: 370px;
    overflow-y: auto;
}

.car-msg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    line-height: 40px;

    .el-button {
        padding: 6px 8px;
    }

    .good-c {
        margin-right: 10px;
    }
}

.goods-price {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    margin-bottom: 5px;
    width: 45px;
}

.goods-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px dashed @border3Color;

    img {
        border: 1px solid @border3Color;
        margin-right: 10px;
        width: 50px;
        height: 50px;
    }

    .good-c {
        margin-right: 10px;
    }

    .goods-n {
        width: 150px;
        height: 25px;
    }
}

.buy-car-title {
    font-size: @font-xs;
    font-weight: bold;
    padding-bottom: 10px;
}

.preorder-content {
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-100%, 0);
    width: 350px;
    height: 450px;
    background: white;
    border: 1px solid @border3Color;
    padding: 10px;
    text-align: left;
    z-index: 99999;
}
</style>
<style lang="less">
.goods-price {
    .el-input .el-input__inner {
        padding: 0 2px !important;
        width: 43px;
    }
}
</style>
